import { Box, Divider } from '@chakra-ui/react';
import RoomDetailCard from '@view/components/Cards/RoomDetail';
import Accommodation from '@data/models/Accommodation';

const images = [
  {
    src: 'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
    thumb:
      'https://cf.bstatic.com/static/img/theme-index/bg_resorts/6e8294d75f648eab2cd2818f0a40854367e584a5.jpg',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1280x900/389243170.jpg?k=642e4b1859a39fa9a05282ccac6b044c6f348adf44fab68f2254e7568628e190&o=&hp=1',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/373544324.jpg?k=92366b37553bf697ed7a488527a6c86d954525ce3184e59d8df2ec550445a618&o=&hp=1',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
  },
  {
    src: 'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
    thumb: 'https://motopress.com/wp-content/uploads/2020/07/hb-land-img-4.jpg',
  },
  {
    src: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
    thumb:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/243304070.jpg?k=756e92c99395e170a04a9a460558b465edae8c2072abb6395728989c9694acb2&o=&hp=1',
  },
];

const accommodation: Accommodation = {
  id: '1',
  packageId: '0',
  rateId: '1',
  name: 'Room 1',
  packageName: 'Standard Rate',
  description:
    'Duchy House is a 19th century building and has both double and single occupancy bedrooms across four floors, with lift access. ',
  adults: 2,
  kids: 1,
  beds: 1,
  maxGuests: 3,
  available: 4,
  notDerivedRate: 0,
  rate: 100,
  nights: 2,
  maxRooms: 2,
  numBeds: 1,
  amenities: [],
  images,
  isPackage: true,
  isPrivate: false,
  packageTerms: 'Test terms',
  packageDescription: 'Test Package Description',
  title: 'test title',
  policy: 'Policy text, 50% off if cancelled 2 days before arrival',
  sourceSettings: {
    bookableLimit: 0,
    capacity: 0,
    canSelectSpecificRoom: false,
    maxRooms: 0,
    roomTypeId: '1',
    title: 'test title',
  },
  accommodations: [],
};

const DemoRoomDetailBox = () => {
  return (
    <Box>
      <h2>Room Detail Box</h2>
      <Divider m={2} />
      <RoomDetailCard accommodation={accommodation} packages={[]} />
    </Box>
  );
};

export default DemoRoomDetailBox;
